import { useTranslation } from "react-i18next";
import { api } from "@/api";

// Compact NL/EN toggle. persist=true stores the choice on the user's account.
export function LanguageSwitcher({ persist = false, dark = false }) {
  const { i18n } = useTranslation();
  const cur = (i18n.resolvedLanguage || i18n.language || "nl").slice(0, 2);

  const set = async (lng) => {
    if (lng === cur) return;
    i18n.changeLanguage(lng);
    try { localStorage.setItem("lang", lng); } catch (e) {}
    if (persist) {
      try { await api.put("/me/language", { language: lng }); } catch (e) {}
    }
  };

  const base = "px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide transition-colors";
  const on = dark ? "bg-white text-slate-900" : "bg-slate-900 text-white";
  const off = dark ? "text-slate-300 hover:text-white" : "text-slate-500 hover:text-slate-900";
  const wrap = dark ? "border-white/20" : "border-slate-200";

  return (
    <div data-testid="lang-switcher" className={`inline-flex overflow-hidden rounded-full border ${wrap}`}>
      {["nl", "en"].map((lng) => (
        <button key={lng} data-testid={`lang-${lng}`} type="button" onClick={() => set(lng)}
          className={`${base} ${cur === lng ? on : off}`}>{lng}</button>
      ))}
    </div>
  );
}
